<cui-navbar #navbar>
  <h1>Materialer</h1>

  <a class="search-materials"
     mat-icon-button
     [disabled]="isOffline"
     routerLink="../search"
     queryParamsHandling="preserve">
    <mat-icon svgIcon="nav/back"></mat-icon>
  </a>
  <span class="fill"></span>
  <button class="panel" mat-icon-button (click)="navbar.toggle()">
    <mat-icon [svgIcon]="navbar.isOpen ? 'nav/close-black' : 'nav/filter'"></mat-icon>
  </button>

  <cui-navbar-panel>
    <div class="result-count">Antal resultater <span class="count">{{ numberOfResults - numberOfHidden }}</span></div>
    <div class="toggle-row">
      <span class="fill truncate">Skjul behandlede</span>
      <mat-slide-toggle cui color="primary" [formControl]="hideHandled"></mat-slide-toggle>
    </div>
  </cui-navbar-panel>
</cui-navbar>

<cui-offline-indicator offline="Venter på netværk" online="Forbindelse oprettet - handlinger synkroniseres"></cui-offline-indicator>

<div class="results" *ngIf="hasLoaded; else loading">

  <div class="no-results" *ngIf="(displayedMaterials | async)?.length === 0">
    <mat-icon svgIcon="no-results"></mat-icon>
    <h1>Oh!</h1>
    <p>Denne materiale liste ser ud til at være tom.</p>
  </div>

  <cui-virtual-scroll [items]="displayedMaterials | async"
                      [itemHeights]="225"
                      (visibleItems)="visibleMaterials = $event"
                      (nearEnd)="loadNextPage()">
    <ng-container *ngFor="let material of visibleMaterials">
      <cui-swipeable [@flyOut]="material.localState && hideHandled.value ? 'hidden' : ''">
        <button (click)="undo(material)" *ngIf="material.canUndo && material.localState" cui-swipeable-action="left">
          <mat-icon svgIcon="material-states/undo"></mat-icon>
          <div>Fortryd</div>
        </button>
        <button (click)="markLost(material)" *ngIf="!material.localState" cui-swipeable-action="left">
          <mat-icon svgIcon="material-states/lost"></mat-icon>
          <div>Bortkommet</div>
        </button>

        <button (click)="undo(material)" *ngIf="material.canUndo && material.localState" cui-swipeable-action="right">
          <mat-icon svgIcon="material-states/undo"></mat-icon>
          <div>Fortryd</div>
        </button>
        <button (click)="markFound(material)" *ngIf="!material.localState" cui-swipeable-action="right">
          <mat-icon svgIcon="material-states/found"></mat-icon>
          <div>Fundet</div>
        </button>

        <app-material [material]="material"
                      [disabled]="material.localState"
                      (click)="showDialog(material)">
        </app-material>
      </cui-swipeable>
      <hr>
    </ng-container>
  </cui-virtual-scroll>

  <cui-pagetip [isShown]="showQueryDescriptor">{{queryDescriptor}}</cui-pagetip>
</div>

<ng-template #loading>
  <mat-card *ngIf="error">
    <mat-card-content>
      {{error}}
    </mat-card-content>
  </mat-card>
  <div class="loading" *ngIf="!error">
    <mat-icon svgIcon="loading"></mat-icon>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/material/material-list/material-list.component.html